import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { reactChildrenValidator } from '../../../validators/react-children';
import { defaultShowtimeContextAssets, showtimeContextAssetsValidator } from './assets';
import { defaultShowtimeContextDisplayText, showtimeContextDisplayTextValidator } from './display-text';
import { showtimeContextEventsValidator } from './events';
export const defaultShowtimeContextProps = {
    showtimeId: undefined,
    assets: defaultShowtimeContextAssets,
    displayText: defaultShowtimeContextDisplayText,
    events: {},
    children: undefined
};
const showtimeContextPropsValidatorSchema = {
    showtimeId: nonEmptyStringValidator,
    assets: showtimeContextAssetsValidator,
    displayText: showtimeContextDisplayTextValidator,
    events: showtimeContextEventsValidator,
    children: reactChildrenValidator
};
export const showtimeContextPropsValidator = Validator.object(showtimeContextPropsValidatorSchema);
